import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/lib/i18n";

import PublicSite from "@/pages/public/PublicSite";
import Login from "@/pages/Login";
import AppShell from "@/pages/app/AppShell";
import SiteEditor from "@/pages/editor/SiteEditor";

function Boot({ children }) {
  const { loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <div className="animate-pulse text-forest font-display text-2xl">Върбица…</div>
      </div>
    );
  }
  return children;
}

const roleHome = {
  OWNER: "/app/dashboard", WAITRESS: "/app/pos",
  KITCHEN: "/app/kds", RECEPTION: "/app/pms",
};

function Protected() {
  const { user } = useAuth();
  if (user === false) return <Navigate to="/login" replace />;
  if (!user) return null;
  return <AppShell />;
}

function OwnerEditor() {
  const { user } = useAuth();
  if (user === false) return <Navigate to="/login" replace />;
  if (!user) return null;
  if (user.role !== "OWNER") return <Navigate to="/app" replace />;
  return <SiteEditor />;
}

function LoginGate() {
  const { user } = useAuth();
  if (user) return <Navigate to={roleHome[user.role] || "/app"} replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LangProvider>
            <Boot>
              <Routes>
                <Route path="/" element={<Navigate to="/site" replace />} />
                <Route path="/site/*" element={<PublicSite />} />
                <Route path="/login" element={<LoginGate />} />
                <Route path="/app/*" element={<Protected />} />
                <Route path="/editor" element={<OwnerEditor />} />
                <Route path="*" element={<Navigate to="/site" replace />} />
              </Routes>
            </Boot>
            <Toaster position="top-right" richColors closeButton />
          </LangProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
